export default {
      id: "icon--santa-show-usage",
      viewBox: "0 0 32 26.5",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--santa-show-usage",
      toString: function () {
        return this.url;
      }
    }